import React from 'react';
export const LoaderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ margin: 'auto', background: 'transparent', display: 'block', shapeRendering: 'auto' }}
    width="161px"
    height="161px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="translate(29.833333333333332,29.833333333333332)">
      <rect x="-10.5" y="-10.5" width="21" height="21" fill="#a0c513">
        <animateTransform
          attributeName="transform"
          type="scale"
          repeatCount="indefinite"
          dur="0.9900990099009901s"
          keyTimes="0;1"
          values="1.31;1"
          begin="-0.297029702970297s"
        ></animateTransform>
      </rect>
    </g>
    <g transform="translate(70.16666666666667,29.833333333333332)">
      <rect x="-10.5" y="-10.5" width="21" height="21" fill="#008bd3">
        <animateTransform
          attributeName="transform"
          type="scale"
          repeatCount="indefinite"
          dur="0.9900990099009901s"
          keyTimes="0;1"
          values="1.31;1"
          begin="-0.19801980198019803s"
        ></animateTransform>
      </rect>
    </g>
    <g transform="translate(29.833333333333332,70.16666666666667)">
      <rect x="-10.5" y="-10.5" width="21" height="21" fill="#a0c513">
        <animateTransform
          attributeName="transform"
          type="scale"
          repeatCount="indefinite"
          dur="0.9900990099009901s"
          keyTimes="0;1"
          values="1.31;1"
          begin="0s"
        ></animateTransform>
      </rect>
    </g>
    <g transform="translate(70.16666666666667,70.16666666666667)">
      <rect x="-10.5" y="-10.5" width="21" height="21" fill="#008bd3">
        <animateTransform
          attributeName="transform"
          type="scale"
          repeatCount="indefinite"
          dur="0.9900990099009901s"
          keyTimes="0;1"
          values="1.31;1"
          begin="-0.09900990099009901s"
        ></animateTransform>
      </rect>
    </g>
  </svg>
);
